import VendorHistoryContainer from '@components/containers/vendorHistory';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorHistory: FC = () => (
    <VendorLayout>
        <VendorHistoryContainer />
    </VendorLayout>
);

export default VendorHistory;
